import { useEffect, useState } from "react";
import { getSyncState } from "@/lib/sync";

// Small dot in the header showing the sync status:
//   • green  = synced (queue empty, no recent error)
//   • amber  = syncing / pending ops in queue
//   • red    = last op failed and will retry
export default function SyncIndicator() {
  const [s, setS] = useState(getSyncState());

  useEffect(() => {
    const handler = (e) => setS(e.detail || getSyncState());
    window.addEventListener("tl:sync-state", handler);
    // Fallback: refresh once on mount (in case an event fired before mount)
    setS(getSyncState());
    return () => window.removeEventListener("tl:sync-state", handler);
  }, []);

  let color = "#8AAE7A"; // sage green (synced)
  let ring = "#B7D2A6";
  let label = "Sincronizzato";
  let pulse = false;
  if (s.error && s.pending > 0) {
    color = "#C97A6A"; // muted terracotta (error)
    ring = "#E4B3A7";
    label = "Errore di sincronizzazione — riproverò a breve";
    pulse = true;
  } else if (s.pending > 0) {
    color = "#D4A574"; // warm amber (syncing)
    ring = "#EAD1AF";
    label = `In sincronizzazione (${s.pending} ${s.pending === 1 ? "modifica" : "modifiche"})`;
    pulse = true;
  }

  return (
    <span
      className="relative inline-flex items-center justify-center w-6 h-6 rounded-full"
      data-testid="sync-indicator"
      data-sync-state={s.error && s.pending > 0 ? "error" : (s.pending > 0 ? "pending" : "synced")}
      title={label}
      aria-label={label}
    >
      {pulse && (
        <span
          className="absolute inline-flex h-2.5 w-2.5 rounded-full opacity-60 animate-ping"
          style={{ backgroundColor: color }}
        />
      )}
      <span
        className="relative inline-flex h-2.5 w-2.5 rounded-full ring-2 transition-colors duration-300"
        style={{ backgroundColor: color, boxShadow: `0 0 0 3px ${ring}33` }}
      />
    </span>
  );
}
